import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import Layout from './index'
import 'typeface-lora'
import 'typeface-karla'

import { rhythm, scale } from '../utils/typography'

const Container = styled.div`
  h2, h3, h4, h5, h6, hgroup, ul, ol, dl, dd, p, figure, pre, table, fieldset, blockquote, form, noscript, iframe, img, hr, address {
    font-family: 'Lora'
  }

  h3 {
    font-weight: 400;
  }

  h1 {
    font-family: 'Karla'
  }
`

class Template extends React.Component {
  render() {
    const { location, children } = this.props
    let header

    // let rootPath = `/`
    // if (typeof __PREFIX_PATHS__ !== `undefined` && __PREFIX_PATHS__) {
    //   rootPath = __PATH_PREFIX__ + `/`
    // }

    if (location.pathname === '/blog' || location.pathname === '/blog/') {
      header = (
        <h1
          style={{
            ...scale(1.5),
            marginBottom: rhythm(1.5),
            marginTop: 0,
          }}
        >
          <Link
            style={{
              boxShadow: 'none',
              textDecoration: 'none',
              color: 'inherit',
            }}
            to={'/blog/'}
          >
            Find Better Questions Blog
          </Link>
        </h1>
      )
    } else {
      header = (
        <h3
          style={{
            fontFamily: 'Karla, sans-serif',
            marginTop: 0,
            marginBottom: rhythm(-1),
          }}
        >
          <Link
            style={{
              boxShadow: 'none',
              textDecoration: 'none',
              color: 'inherit',
            }}
            to={'/blog/'}
          >
            Find Better Questions Blog
          </Link>
        </h3>
      )
    }
    return (
      <Layout>
        <Container
          style={{
            maxWidth: rhythm(24 + (this.props.addedWidth || 0)),
            padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
            margin: '0 auto'
          }}
          >
            {header}
            {children}
          </Container>
      </Layout>
    )
  }
}

export default Template
